module.exports = __webpack_public_path__ + "img/default-device.72debe14.png";